import { combineReducers } from "redux";

import forms from "./forms/reducer";
import notifications from "./notifications/reducer";
import users from "./users/reducer";
import sellers from "./sellers/reducer";
import appOptions from "./appOptions/reducer";
import feeds from "./feeds/reducer";
import warehouses from "./warehouses/reducer";
import chat from "./chat/reducer";
import orders from "./orders/reducer";
import stocks from "./stocks/reducer";
import stocksFBO from "./stocksFBO/reducer";
import delivery from "./delivery/reducer";
import stocksExport from "./stocksExport/reducer";
import stocksReserve from "./stocksReserve/reducer";
import theme from "./theme/reducer";
import shortcuts from "./shortcuts/reducer";

const rootReducer = combineReducers({
    forms,
    notifications,
    users,
    sellers,
    appOptions,
    feeds,
    warehouses,
    chat,
    orders,
    stocks,
    stocksFBO,
    stocksExport,
    stocksReserve,
    delivery,
    theme,
    shortcuts
})

export default rootReducer;

